<aslib-title ></aslib-title>

<form novalidate [formGroup]='formConsultaRoyalties'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Mês/Ano Referência:</label>
    <div class="controls col-2">
      <input type="text" appMonthYear placeholder="MM/AAAA" formControlName="dataReferenciaMunicipio" [(ngModel)]="filtro.dataVigencia" required  class="form-control"/>
    </div>
  </div>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Municípios:</label>
    <div class="controls col-md-3">
      <search-dropdown
                        id="municipios"
                        [items]="dadosMunicipiosCombo"
                        [label]="'NomeMunicipio'"
                        [uid]="'CodigoMunicipio'"                          
                        [(ngModel)]="filtro.codMunicipio"
                        [defaultLabel] = "'Todos'"
                        [ngModelOptions]="{standalone: true}"                                        
                    >
                    </search-dropdown>
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary" (click)="filtrar(grid)" >
        <aslib-icon type="1" icon="fa fa-search"></aslib-icon>Filtrar</button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar </button>
    </div>
    
  </div>

</form>
  <div class="form-group row" >
    <div class="col-md-12 text-right">
      <button type="submit" class="btn btn-primary" (click)="irPraAdicionar()"  >
        <aslib-icon type="1" icon="fa fa-plus"></aslib-icon>Adicionar Municípios Aptos
      </button>
    </div>
    </div>

<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid #grid id="as-libgrid" class="col-md-12" [(dataset)]="dadosMunicipiosAptos" [pagination]="true">
    
    
    <aslib-grid-column [property]="'NomeMunicipio'" [header]="'Município'" [width]="100" [sortable]="true"></aslib-grid-column>

    <aslib-grid-column [property]="'DataInicioVigenciaFormatada'"  [width]="60" [header]="'Início Vigência'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.DataInicioVigenciaFormatada}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'DataFimVigenciaFormatada'"  [width]="50" [header]="'Fim Vigência'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{item.DataFimVigenciaFormatada}}</span>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'DescricaoObservacao'" [header]="'Observações'" [width]="100" [sortable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="40" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <button type="button" class="btn btn-sm btn-primary" title="Editar"
          ascas-data="Editar item" (click)="editar(detalheLiq,item)">
          <aslib-icon type="1" icon="fa fa-pencil"></aslib-icon>
        </button>
        <button type="button" class="btn btn-sm btn-primary" title="Excluir"
          ascas-data="Excluir registro" (click)="excluir(modalMensagem,item)">
          <aslib-icon type="1" icon="fa fa-trash"></aslib-icon>
        </button>
      </ng-template>
    </aslib-grid-column>
  </aslib-grid>
</div>
  <div class="form-group row"  *ngIf="exibirGrid">
        <div class="col-md-1">
      <button type="submit" class="btn btn-primary" (click)="gerarRelatorio()"  >
        <aslib-icon type="1" icon="fa fa-save"></aslib-icon>Excel
      </button>
    </div>
  </div>
<div class="card-block">  
  <div class="row">
    <div class="col-md-10">
    <ng-template #detalheLiq>
      <sarf-detalhe-municipio-apto [municipioSelecionado]="itemSelecionado" (onConfirm)="onConfirmPropagar($event)" (onClose)="onClose($event)"></sarf-detalhe-municipio-apto>
    </ng-template>
    </div>
  </div>
<aslib-modal #modalMensagem></aslib-modal>
  </div>


// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/consulta-municipios-aptos.component.html